import { render, staticRenderFns } from "./TrangTaoDonVi.vue?vue&type=template&id=2cc64a72&"
import script from "./TrangTaoDonVi.vue?vue&type=script&lang=js&"
export * from "./TrangTaoDonVi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports